import React from 'react'

function VehicleDescription({vehicle}) {
  return (
    
<div className="flex flex-col items-start max-w-4xl lg:w-[56rem] p-6 bg-white border border-gray-200 rounded-lg shadow-2xl sm:mx-5 gap-3 w-full">

<h5 className="mb-2 text-2xl font-bold tracking-tight text-gray-900 ">Vehicle Description</h5>
<p className="font-normal text-gray-700 "><b>Name: </b>{vehicle.name}</p>
<p className="font-normal text-gray-700 "><b>Type: </b>{vehicle.type}</p>
<p className="font-normal text-gray-700 "><b>District: </b>{vehicle.district}</p>
<p className="font-normal text-gray-700 "><b>City: </b>{vehicle.city}</p>
<p className="font-normal text-gray-700 "><b>Available Seats: </b>{vehicle.availableSeats}</p>
<p className="font-normal text-gray-700 text-justify"><b>Description: </b>{vehicle.description}</p>

</div>

  )
}

export default VehicleDescription